import { action, observable } from 'mobx'
import { mustBeInRange } from '@/utils/validx-util'
import { required, validationContext } from 'validx'
import { type InventoryItemPricingEditor } from './inventory-item-pricing-editor'
import {
  type InventoryItemFeeValues,
  type InventoryItemPricingValues,
} from '@/features/inventory/inventory-item-pricing-values'

/**
 * View Model for Inventory Items of type Fee.
 */
export class FeeEditorViewModel implements InventoryItemPricingEditor {
  /**
   * The chosen fee.
   */
  @observable accessor fee = 0

  /**
   * The validation context.
   */
  readonly validation = validationContext(this, {
    fee: [
      required('A fee amount is required.'),
      mustBeInRange(0, Infinity, 'A fee must be 0 or greater.'),
    ],
  })

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * @inheritdoc
   */
  @action.bound
  hydrate(values: InventoryItemFeeValues): void {
    this.fee = values.fee
  }

  /**
   * @inheritdoc
   */
  toValues(): InventoryItemPricingValues {
    return {
      type: 'Fee',
      fee: this.fee,
    }
  }

  /**
   * @inheritdoc
   */
  @action.bound
  reset() {
    this.fee = 0
    this.validation.reset()
  }
}
